export default __webpack_public_path__ + "static/media/International Conveyors Limited.8959972e.jpg";